module.exports = __webpack_public_path__ + "img/right-registerpage@2x.0545103e.png";